const searchProduct = () => {
  const searchForm = document.querySelector(".search-form");
  searchForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const searchedInput = document.querySelector("#search-input").value;
    if (!searchedInput)
      return;

    const queryParams = new URLSearchParams(window.location.search);


    const selectEle = document.querySelector("#results-per-page");

    if (selectEle.value)
      queryParams.set("rpp", selectEle.value)


    queryParams.set("search", searchedInput)

    window.location.href = `https://www.legendary-parts.com/pages/search-product-by-pn?${queryParams.toString()}`;
  })
}
searchProduct()
function changeResultsPerPage() {
  const selectEle = document.querySelector("#results-per-page-select");
  selectEle.addEventListener("change", (e) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("rpp", e.target.value)
    queryParams.set("page", 1)
    if (queryParams.get("search"))
      window.location.href = `https://www.legendary-parts.com/pages/search-product-by-pn?${queryParams.toString()}`

  })
  const queryParams = new URLSearchParams(window.location.search);

  if (queryParams.get("rpp")) {
    selectEle.value = queryParams.get("rpp") || 10
  }

}
changeResultsPerPage()

function setInputValueonLoad() {
  const queryParams = new URLSearchParams(window.location.search);
  const searchInput = document.querySelector("#search-input");
  searchInput.value = queryParams.get("search")
}
setInputValueonLoad()

function loadingStateStart(start) {
  const notFound = document.querySelector("#not-found");

  notFound.style.display = "none"
  const productsTablecontainer = document.querySelector("#products-table-container");
  productsTablecontainer.style.display = "none";

  const loader = document.querySelector(".api-loading");
  if (!start) {
    loader.style.display = "none";

  } else {
    loader.style.display = "flex";
  }
}

function loadingStateEnd(success) {
  if (success) {
    const productsTablecontainer = document.querySelector("#products-table-container");
    productsTablecontainer.style.display = "block";

  } else {
    const notFound = document.querySelector("#not-found")
    notFound.style.display = "block";


  }
  const loader = document.querySelector(".api-loading");
  loader.style.display = "none";

}

async function getProductsByPN(input) {

  const selectEle = document.querySelector(".results-per-page-container");
  selectEle.style.display = "none";
  const queryParams = new URLSearchParams(window.location.search);

  input = !input ? queryParams.get("search") : input;
  const searchSomething = document.querySelector("#search-something");

  if (!input) {
    const searchedField = document.querySelector("#search-input");
    searchedField.focus();
    searchedField.value = "";

    searchSomething.style.display = "block";
  }
  else
    searchSomething.style.display = "none";

  loadingStateStart(input)
  if (!input)
    return


  const apiQueryParams = new URLSearchParams();
  let pageNo = queryParams.get("pg")
  if (!queryParams.get("pg")) {
    pageNo = 1
  }
  apiQueryParams.append("page", pageNo);
  if (queryParams.get("rpp"))
    apiQueryParams.append("rpp", queryParams.get("rpp"));
  if (queryParams.get("lang"))
    apiQueryParams.set("lang", queryParams.get("lang"))


  const baseApiUrl = "https://admin-lp.com";
  const apiUrl = `${baseApiUrl}/api/products/search/${input}?${apiQueryParams.toString()}`;

  const res = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'ngrok-skip-browser-warning': true
    },
  })

  if (res.status < 300) {
    const data = await res.json();

    if (data?.productsList?.length > 0) {
      const productsTablecontainer = document.querySelector("#products-table-container");
      const productsTableBody = productsTablecontainer.querySelector("table").querySelector("tbody");

      data.productsList.forEach(product => {
        const tr = document.createElement("tr");
        const tds = [];
        for (let i = 0; i < 7; i++) {
          const td = document.createElement("td");
          td.classList.add("bg-transparent")
          tds.push(td)
        }

        const year = product.subCategory.category.model.categoriesMoto.year;
        tds[0].innerText = year.yearNumber;
        const categoriesMoto = product.subCategory.category.model.categoriesMoto;
        tds[1].innerText = categoriesMoto.categoriesMotoName;

        const model = product.subCategory.category.model;
        tds[2].innerText = model.modelName;

        // const category = product.subCategory.category;
        // tds[3].innerText = category.categoryName;

        const subCategory = product.subCategory;
        tds[3].innerText = subCategory.subCategoryName;

        tds[4].innerText = product.ref;
        tds[5].innerText = product.partNumber;
        tds[6].innerText = product.description;
        tr.onclick = (e) => {
          const nextPageQueryParams = new URLSearchParams();
          nextPageQueryParams.set("subCategoryId", product.subCategory.id);
          nextPageQueryParams.set("productId", product.id);
          if (queryParams.get("lang"))
            nextPageQueryParams.set("lang", queryParams.get("lang"))

          const productsPageUrl = `https://www.legendary-parts.com/pages/microfiches-product?${nextPageQueryParams.toString()}`

          if (e.ctrlKey) window.open(productsPageUrl, '_blank');

          else window.location.href = productsPageUrl
        }
        tr.classList.add("product-info-row")
        for (let i = 0; i < tds.length; i++)
          tr.appendChild(tds[i])

        productsTableBody.appendChild(tr);


      })
      selectEle.style.display = "flex";
      loadingStateEnd(true);
      const baseUrlForCurrentPage = "https://www.legendary-parts.com/pages/search-product-by-pn";
      const leftArrow = document.querySelector(".left-arrow");


      const paginationParams = new URLSearchParams();
      const currentPage = Number(pageNo)
      paginationParams.set("pg", currentPage - 1);
      paginationParams.set("rpp", queryParams.get("rpp") || 10);
      paginationParams.set("search", input);

      if (queryParams.get("lang"))
        paginationParams.set("lang", queryParams.get("lang"))


      const rpp = queryParams.get("rpp") || 10
      if (currentPage === 1)
        leftArrow.style.display = "none";
      else
        leftArrow.setAttribute("href", `${baseUrlForCurrentPage}?${paginationParams.toString()}`)


      const pagesContainer = document.querySelector(".page-numbers");
      let start = 0;
      if (currentPage >= 10) {
        start = currentPage - 10 + 1
      }

      for (let i = 0; i < data.totalPages; i++) {

        if (currentPage - 4 > i) {
          continue;

        }
        let current = "";
        const large = currentPage + 4

        if (currentPage === i + 1)
          current = 'class="current-page"';

        const loopQueryParams = new URLSearchParams();
        loopQueryParams.set("search", input);
        loopQueryParams.set("pg", i + 1);
        if (queryParams.get("lang"))
          loopQueryParams.set("lang", queryParams.get("lang"))
        loopQueryParams.set("rpp", queryParams.get("rpp") || 10);
        const url = `https://www.legendary-parts.com/pages/search-product-by-pn?${loopQueryParams.toString()}`;
        let span = "";
        if (large < i && (i + 1 < data.totalPages))
          span = "<span>...</span>";


        pagesContainer.innerHTML = pagesContainer.innerHTML + `<a href="${url}" ${current}>${i + 1}</a>${span}`;

        if (large < i)
          break;

      }


      const rightArrow = document.querySelector(".right-arrow");


      if (Number(pageNo) === data.totalPages)
        rightArrow.style.display = "none";
      else {
        const nextPageQueryParams = new URLSearchParams();
        nextPageQueryParams.set("search", input);
        nextPageQueryParams.set("pg", Number(pageNo) + 1);
        nextPageQueryParams.set("rpp", queryParams.get("rpp") || 10);
        if (queryParams.get("lang"))
          nextPageQueryParams.set("lang", queryParams.get("lang"));

        rightArrow.setAttribute("href", `${baseUrlForCurrentPage}?${nextPageQueryParams.toString()}`)
      }
    }
    else {
      loadingStateEnd(false)
    }

  } else
    loadingStateEnd(false)
}